import { Outlet } from 'react-router-dom';
import { useApplyLanguage } from '@/hooks/useLanguage';

const LanguageLayout = () => {
  const isReady = useApplyLanguage();

  // children render only after language switch, so they won't miss the change event
  return isReady ? <Outlet /> : null;
};

export default LanguageLayout;
